export default function ABOUT() {

  $(()=>{
    $.when(
      window.load['about-nav']
    ).done(() => $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999}) )
  })
  
}